// 宮崎県産業クイズ100問
export const quizData = [
  // 第1部:産業構造・統計編 (問1-10)
  {
    id: 1,
    category: "産業構造・統計",
    question: "2022年(令和4年)の宮崎県の製造品出荷額等は、前年比でどのくらい増減しましたか?",
    options: [
      "1.2%減少",
      "0.7%増加",
      "6.2%増加",
      "17.1%増加"
    ],
    correctAnswer: 2,
    explanation: "2022年(令和4年)における宮崎県の製造品出荷額等は、前年比で6.2%の増加を記録しました。これは県内産業が堅調な成長軌道にあることを示しています。"
  },
  {
    id: 2,
    category: "産業構造・統計",
    question: "2022年(令和4年)において、宮崎県の製造品出荷額等で最も大きな割合を占める業種は何ですか?",
    options: [
      "電子部品・デバイス・電子回路製造業",
      "飲料・たばこ・飼料製造業",
      "化学工業",
      "食料品製造業"
    ],
    correctAnswer: 3,
    explanation: "2022年において、宮崎県の製造品出荷額等で最も大きな割合を占めるのは食料品製造業で、全体の23.0%に相当する4,184億円を記録しました。"
  },
  {
    id: 3,
    category: "産業構造・統計",
    question: "2022年(令和4年)の宮崎県の製造品出荷額等、約1兆8,195億円のうち、「食料品製造業」が占める割合は何%ですか?",
    options: [
      "10.7%",
      "11.5%",
      "18.7%",
      "23.0%"
    ],
    correctAnswer: 3,
    explanation: "食料品製造業は4,184億円で、全体の23.0%を占めており、県内製造業の最大セクターとなっています。"
  },
  {
    id: 4,
    category: "産業構造・統計",
    question: "2022年(令和4年)の宮崎県の製造品出荷額等で第2位の「電子部品・デバイス・電子回路製造業」の出荷額はいくらですか?",
    options: [
      "4,184億円",
      "2,096億円",
      "1,950億円",
      "1,148億円"
    ],
    correctAnswer: 1,
    explanation: "電子部品・デバイス・電子回路製造業の出荷額は2,096億円で、全体の11.5%を占め、第2位となっています。"
  },
  {
    id: 5,
    category: "産業構造・統計",
    question: "2022年(令和4年)の宮崎県の製造業における付加価値額で、食料品製造業、電子部品・デバイス・電子回路製造業に次いで第3位となった業種は何ですか?",
    options: [
      "飲料・たばこ・飼料製造業",
      "化学工業",
      "衣服・その他の繊維製品製造業",
      "鉄鋼業"
    ],
    correctAnswer: 1,
    explanation: "付加価値額で見ると、化学工業が9.0%を占め、重要なセクターとなっています。"
  },
  {
    id: 6,
    category: "産業構造・統計",
    question: "2002年(平成14年)の宮崎県の製造品出荷額等で、構成比が最も高かった業種は何ですか?",
    options: [
      "電子部品",
      "飲料・たばこ",
      "食料品",
      "化学"
    ],
    correctAnswer: 2,
    explanation: "2002年のデータでは、食料品が19.7%で最も高い構成比を示していました。"
  },
  {
    id: 7,
    category: "産業構造・統計",
    question: "2002年(平成14年)の産業類型別構成比で、最も割合が高かったのは次のうちどれですか?",
    options: [
      "生活関連型",
      "基礎素材型",
      "加工組立型",
      "エネルギー多消費型"
    ],
    correctAnswer: 0,
    explanation: "2002年の産業類型別では、生活関連型の割合が最も高くなっていました。"
  },
  {
    id: 8,
    category: "産業構造・統計",
    question: "宮崎県の製造品で、かつて出荷額が全国1位になったことがある品目として挙げられていないものは次のうちどれですか?",
    options: [
      "硝酸(98%換算)",
      "液晶テレビ",
      "線形回路",
      "ニット製乳幼児用外衣"
    ],
    correctAnswer: 3,
    explanation: "硝酸、液晶テレビ、線形回路は宮崎県で全国1位になったことがある品目として記録されています。"
  },
  {
    id: 9,
    category: "産業構造・統計",
    question: "2022年(令和4年)の宮崎県の製造業の従業者数は約何人ですか?",
    options: [
      "34,097人",
      "54,097人",
      "62,270人",
      "75,000人"
    ],
    correctAnswer: 1,
    explanation: "2022年の宮崎県の製造業の従業者数は約54,097人となっています。"
  },
  {
    id: 10,
    category: "産業構造・統計",
    question: "2022年(令和4年)の宮崎県の製造業の付加価値額は、前年比でどのくらい増減しましたか?",
    options: [
      "6.2%増加",
      "0.7%増加",
      "1.2%減少",
      "9.0%減少"
    ],
    correctAnswer: 2,
    explanation: "2022年の付加価値額は前年比で1.2%減少しました。"
  },

  // 第2部:霧島酒造編 (問11-25)
  {
    id: 11,
    category: "霧島酒造",
    question: "霧島酒造の創業者は誰ですか?",
    options: [
      "江夏順吉",
      "江夏順行",
      "江夏吉助",
      "江夏源助"
    ],
    correctAnswer: 2,
    explanation: "霧島酒造は1916年(大正5年)に江夏吉助によって都城市で創業されました。"
  },
  {
    id: 12,
    category: "霧島酒造",
    question: "霧島酒造が創業したのは西暦何年ですか?",
    options: [
      "1914年(大正3年)",
      "1916年(大正5年)",
      "1932年(昭和7年)",
      "1955年(昭和30年)"
    ],
    correctAnswer: 1,
    explanation: "霧島酒造は1916年(大正5年)に創業されました。"
  },
  {
    id: 13,
    category: "霧島酒造",
    question: "霧島酒造が焼酎造りの近代化を進めた2代目社長・江夏順吉が掘り当てた、独自の仕込み水の名称は何ですか?",
    options: [
      "霧島天然水",
      "霧島裂罅水",
      "都城名水",
      "黄金千貫水"
    ],
    correctAnswer: 1,
    explanation: "1955年(昭和30年)に地下深くから掘り当てた水は「霧島裂罅水(キリシマレッカスイ)」と命名され、霧島酒造の品質を決定づける重要な要素となりました。"
  },
  {
    id: 14,
    category: "霧島酒造",
    question: "霧島酒造の主力商品「黒霧島」が全国発売されたのは西暦何年ですか?",
    options: [
      "1996年",
      "1998年",
      "1999年",
      "2003年"
    ],
    correctAnswer: 2,
    explanation: "「黒霧島」は1998年に宮崎県限定で発売され、翌1999年に全国発売されました。"
  },
  {
    id: 15,
    category: "霧島酒造",
    question: "「黒霧島」の製造で蘇らせた、創業当時の製法の特徴は何ですか?",
    options: [
      "白麹仕込み",
      "黄麹仕込み",
      "黒麹仕込み",
      "芋麹仕込み"
    ],
    correctAnswer: 2,
    explanation: "「黒霧島」は創業当時の黒麹仕込みを現代に蘇らせた商品として、全国的な焼酎ブームの火付け役となりました。"
  },
  {
    id: 16,
    category: "霧島酒造",
    question: "紫芋「ムラサキマサリ」を原料芋として使用している霧島酒造の商品はどれですか?",
    options: [
      "黒霧島",
      "白霧島",
      "茜霧島",
      "赤霧島"
    ],
    correctAnswer: 3,
    explanation: "2003年(平成15年)に発売された「赤霧島」は紫芋「ムラサキマサリ」を使用しています。"
  },
  {
    id: 17,
    category: "霧島酒造",
    question: "オレンジ芋「タマアカネ」を原料芋として使用している霧島酒造の商品はどれですか?",
    options: [
      "赤霧島",
      "茜霧島",
      "吉助",
      "KIRISHIMA No.8"
    ],
    correctAnswer: 1,
    explanation: "2014年(平成26年)に発売された「茜霧島」はオレンジ芋「タマアカネ」を使用しています。"
  },
  {
    id: 18,
    category: "霧島酒造",
    question: "霧島酒造が初めて焼酎業界で売上1位を達成したのは、どの年度ですか?",
    options: [
      "2009年度",
      "2012年度",
      "2015年度",
      "2018年度"
    ],
    correctAnswer: 1,
    explanation: "霧島酒造は2012年度に初めて焼酎業界での売上日本一を達成しました。"
  },
  {
    id: 19,
    category: "霧島酒造",
    question: "霧島酒造の本社および本社工場が所在する都市はどこですか?",
    options: [
      "宮崎市",
      "延岡市",
      "日南市",
      "都城市"
    ],
    correctAnswer: 3,
    explanation: "霧島酒造は都城市に本社を置き、市内に本社工場や志比田工場など複数の生産拠点を構えています。"
  },
  {
    id: 20,
    category: "霧島酒造",
    question: "霧島酒造の2代目社長・江夏順吉が開発したとされる独自の蒸留機の名称は何ですか?",
    options: [
      "順吉式蒸留機",
      "江夏式E-Ⅱ型蒸留機",
      "霧島式減圧蒸留機",
      "都城式常圧蒸留機"
    ],
    correctAnswer: 1,
    explanation: "江夏順吉は独自の「江夏式蒸留機」を開発するなど、技術革新に情熱を注ぎました。"
  },
  {
    id: 21,
    category: "霧島酒造",
    question: "霧島酒造が芋焼酎の原料芋として「黄金千貫(コガネセンガン)」の使用を開始したのは、およそどの年代ですか?",
    options: [
      "1950年代",
      "1960年代後半",
      "1980年代",
      "1990年代"
    ],
    correctAnswer: 1,
    explanation: "霧島酒造は1960年代後半から黄金千貫を使用し始めました。"
  },
  {
    id: 22,
    category: "霧島酒造",
    question: "霧島酒造の「志比田工場 黒霧島原酒」の商品説明で、「原酒」の定義として正しいものはどれですか?",
    options: [
      "蒸留後に水を加えたアルコール分36%以上のもの",
      "蒸留後に一切のものを加えず、かつアルコール分が36%以上のもの",
      "蒸留後に熟成させ、アルコール分が25%以上のもの",
      "蒸留後にブレンドせず、かつアルコール分が20%以上のもの"
    ],
    correctAnswer: 1,
    explanation: "原酒とは蒸留後に一切のものを加えず、かつアルコール分が36%以上のものを指します。"
  },
  {
    id: 23,
    category: "霧島酒造",
    question: "霧島酒造が運営する、ブルワリーやベーカリー、ミュージアムなどを備えた複合施設の名称は何ですか?",
    options: [
      "霧島リサイクル協同組合",
      "霧島グリーンビレッジ",
      "霧島ファクトリーガーデン",
      "霧島自然農園"
    ],
    correctAnswer: 2,
    explanation: "「焼酎の里 霧島ファクトリーガーデン」は地域文化にも貢献する複合施設です。"
  },
  {
    id: 24,
    category: "霧島酒造",
    question: "霧島酒造が宮崎県限定で「黒霧島」を発売したのは西暦何年ですか?",
    options: [
      "1996年",
      "1998年",
      "1999年",
      "2000年"
    ],
    correctAnswer: 1,
    explanation: "「黒霧島」は1998年に宮崎県限定で発売されました。"
  },
  {
    id: 25,
    category: "霧島酒造",
    question: "霧島酒造の3代目社長に江夏順行が就任したのは西暦何年ですか?",
    options: [
      "1986年",
      "1996年",
      "2006年",
      "2016年"
    ],
    correctAnswer: 1,
    explanation: "1996年(平成8年)に3代目社長として江夏順行が就任しました。"
  },

  // 第3部:先端製造業編 (問26-40)
  {
    id: 26,
    category: "先端製造業",
    question: "宮崎市高岡町に大規模な工場を持つ日機装の子会社の正式名称は何ですか?",
    options: [
      "日機装宮崎",
      "宮崎日機装株式会社",
      "株式会社日機装エアロスペース宮崎",
      "株式会社宮崎インダストリアル"
    ],
    correctAnswer: 1,
    explanation: "2017年に宮崎市高岡町に設立された宮崎日機装株式会社は、日機装グループの最重要生産拠点の一つです。"
  },
  {
    id: 27,
    category: "先端製造業",
    question: "宮崎日機装の航空宇宙工場が製造し、世界の民間ジェット機の95%以上に採用されている主力製品は何ですか?",
    options: [
      "エルロン(補助翼)",
      "カスケード(逆推力装置部品)",
      "クライオジェニックポンプ",
      "人工透析装置"
    ],
    correctAnswer: 1,
    explanation: "ジェットエンジンの逆推力装置に不可欠な部品である「カスケード」は、世界の民間ジェット機の95%以上に採用されています。"
  },
  {
    id: 28,
    category: "先端製造業",
    question: "宮崎日機装が製造する「カスケード」に使用されている主な素材は何ですか?",
    options: [
      "チタン合金",
      "アルミニウム合金",
      "炭素繊維強化プラスチック(CFRP)",
      "ステンレス鋼"
    ],
    correctAnswer: 2,
    explanation: "カスケードは炭素繊維強化プラスチック(CFRP)という軽量かつ高強度な素材で作られています。"
  },
  {
    id: 29,
    category: "先端製造業",
    question: "宮崎日機装のインダストリアル工場が製造する「クライオジェニックポンプ」は、主にどのような物質の移送に使用されますか?",
    options: [
      "水素",
      "アンモニア",
      "高温の化学薬品",
      "-162℃の液化天然ガス(LNG)"
    ],
    correctAnswer: 3,
    explanation: "-162℃の液化天然ガス(LNG)を移送するためのクライオジェニックポンプを製造できる企業は世界に2社しかなく、宮崎日機装はそのうちの1社です。"
  },
  {
    id: 30,
    category: "先端製造業",
    question: "日機装が日本で初めて開発に成功した医療機器は何ですか?",
    options: [
      "MRI装置",
      "人工心肺装置",
      "人工透析装置",
      "ペースメーカー"
    ],
    correctAnswer: 2,
    explanation: "日機装は1969年に日本で初めて人工透析装置を開発したパイオニアです。"
  },
  {
    id: 31,
    category: "先端製造業",
    question: "宮崎日機装の敷地内に設置された、医療関連の研究研修施設の名称は何ですか?",
    options: [
      "宮崎メディカルセンター",
      "NIKKISOメディテック宮崎",
      "M-LET(エムレット)宮崎",
      "宮崎ライフサイエンス研究所"
    ],
    correctAnswer: 2,
    explanation: "宮崎の敷地内には医療関連の研究研修施設「M-LET(エムレット)宮崎」も設置されています。"
  },
  {
    id: 32,
    category: "先端製造業",
    question: "宮崎日機装が部品を製造している、次世代の移動手段「空飛ぶクルマ」の略称は何ですか?",
    options: [
      "UAV",
      "EV",
      "FCV",
      "eVTOL"
    ],
    correctAnswer: 3,
    explanation: "次世代の移動手段として注目される「空飛ぶクルマ」(eVTOL)の部品開発にも着手しています。"
  },
  {
    id: 33,
    category: "先端製造業",
    question: "旭化成が延岡市で世界で唯一製造している再生セルロース繊維のブランド名は何ですか?",
    options: [
      "レオナ",
      "ベンベルグ",
      "アサヒボロン",
      "サランラップ"
    ],
    correctAnswer: 1,
    explanation: "延岡工場は、高級衣料の裏地などに使われる再生セルロース繊維「ベンベルグ(キュプラ)」を製造する、世界で唯一の工場です。"
  },
  {
    id: 34,
    category: "先端製造業",
    question: "旭化成が延岡市でベンベルグ工場の操業を開始したのは西暦何年ですか?",
    options: [
      "1916年",
      "1931年",
      "1951年",
      "1964年"
    ],
    correctAnswer: 1,
    explanation: "1931年に旭化成がベンベルグ工場の操業を開始して以来、延岡市は日本有数の化学工業都市として発展してきました。"
  },
  {
    id: 35,
    category: "先端製造業",
    question: "旭化成のベンベルグ工場が所在する都市はどこですか?",
    options: [
      "宮崎市",
      "日向市",
      "延岡市",
      "都城市"
    ],
    correctAnswer: 2,
    explanation: "旭化成の延岡工場は延岡市にあり、世界で唯一のベンベルグ製造拠点です。"
  },
  {
    id: 36,
    category: "先端製造業",
    question: "ミネベアミツミの宮崎工場が主に製造している製品分野は何ですか?",
    options: [
      "航空機部品",
      "医療機器",
      "自動車部品",
      "半導体"
    ],
    correctAnswer: 2,
    explanation: "ミネベアミツミは宮崎市佐土原町に自動車部品を製造する大規模な工場を運営しています。"
  },
  {
    id: 37,
    category: "先端製造業",
    question: "ミネベアミツミの宮崎工場が所在するのは宮崎市のどの地区ですか?",
    options: [
      "高岡町",
      "清武町",
      "佐土原町",
      "田野町"
    ],
    correctAnswer: 2,
    explanation: "ミネベアミツミの宮崎工場は宮崎市佐土原町にあり、2023年1月から現在の体制で操業しています。"
  },
  {
    id: 38,
    category: "先端製造業",
    question: "宮崎キヤノン株式会社が2019年に新工場を完成させたのは、宮崎県のどの町ですか?",
    options: [
      "三股町",
      "綾町",
      "新富町",
      "高鍋町"
    ],
    correctAnswer: 3,
    explanation: "宮崎キヤノンは2019年に児湯郡高鍋町に最新鋭の工場を完成させました。"
  },
  {
    id: 39,
    category: "先端製造業",
    question: "宮崎日機装の敷地面積は、東京ドームおよそ何個分と説明されていますか?",
    options: [
      "3個分",
      "6個分",
      "9個分",
      "12個分"
    ],
    correctAnswer: 1,
    explanation: "宮崎日機装の広大な敷地内には2つの工場があり、その規模は東京ドーム約6個分に相当します。"
  },
  {
    id: 40,
    category: "先端製造業",
    question: "日機装が開発した、深紫外線LEDを使用した空間除菌消臭装置のシリーズ名は何ですか?",
    options: [
      "エアロクリーン",
      "エアロピュア",
      "ピュアプロテクト",
      "UVバスター"
    ],
    correctAnswer: 1,
    explanation: "日機装は深紫外線LED技術を活用した「エアロピュア」などの製品を開発しています。"
  },

  // 第4部:商業・金融編 (問41-55)
  {
    id: 41,
    category: "商業・金融",
    question: "宮崎市の中心市街地を南北に貫くメインストリートの名称は何ですか?",
    options: [
      "高千穂通り",
      "橘通り",
      "一番街",
      "若草通り"
    ],
    correctAnswer: 1,
    explanation: "宮崎市の商業の中心は、歴史的に「橘通り(たちばなどおり)」が担ってきました。"
  },
  {
    id: 42,
    category: "商業・金融",
    question: "宮崎山形屋や旧橘百貨店などが立地し、1950年代から宮崎市の商業の中心地として栄えたのは橘通りの何丁目周辺ですか?",
    options: [
      "一丁目",
      "三丁目",
      "四丁目",
      "五丁目"
    ],
    correctAnswer: 1,
    explanation: "1950年代には宮崎山形屋や橘百貨店といった大型百貨店が橘通り三丁目周辺に相次いで開業・移転し、大きな賑わいを見せました。"
  },
  {
    id: 43,
    category: "商業・金融",
    question: "宮崎県最大の歓楽街の通称は何ですか?",
    options: [
      "ヒガシタチ",
      "ニシタチ",
      "キタタチ",
      "ミナミタチ"
    ],
    correctAnswer: 1,
    explanation: "橘通りの西側に広がる県内最大の歓楽街「ニシタチ」は、1000店舗以上がひしめき合っています。"
  },
  {
    id: 44,
    category: "商業・金融",
    question: "歓楽街「ニシタチ」が発展するきっかけとなった、1950年代に払い下げられた土地は何の跡地でしたか?",
    options: [
      "旧宮崎県庁の跡地",
      "旧陸軍の演習場跡地",
      "旧国鉄の寮跡地",
      "旧宮崎空港の滑走路跡地"
    ],
    correctAnswer: 2,
    explanation: "このエリアは、1950年代に旧国鉄の寮跡地が払い下げられたことをきっかけに飲食店街として発展しました。"
  },
  {
    id: 45,
    category: "商業・金融",
    question: "2025年1月1日基準日の地価公示で、宮崎県の商業地は何年ぶりに上昇に転じましたか?",
    options: [
      "15年ぶり",
      "24年ぶり",
      "34年ぶり",
      "40年ぶり"
    ],
    correctAnswer: 2,
    explanation: "2025年1月1日を基準日とする地価公示では、宮崎県の商業地が1991年以来、実に34年ぶりに上昇に転じました。"
  },
  {
    id: 46,
    category: "商業・金融",
    question: "宮崎県都城市で創業し、全国に展開するホームセンターチェーンは何ですか?",
    options: [
      "ナフコ",
      "ハンズマン",
      "グッデイ",
      "ニシムタ"
    ],
    correctAnswer: 1,
    explanation: "宮崎県発の企業で、独自のビジネスモデルで成功を収めた代表例が、ホームセンターチェーンの「ハンズマン」です。"
  },
  {
    id: 47,
    category: "商業・金融",
    question: "ハンズマンのルーツとなった事業が創業されたのは西暦何年ですか?",
    options: [
      "1914年",
      "1946年",
      "1964年",
      "1986年"
    ],
    correctAnswer: 0,
    explanation: "そのルーツは1914年に都城市で創業された建材店に遡ります。"
  },
  {
    id: 48,
    category: "商業・金融",
    question: "ハンズマンのホームセンター1号店「吉尾店」が開店した都市はどこですか?",
    options: [
      "宮崎市",
      "延岡市",
      "都城市",
      "日南市"
    ],
    correctAnswer: 2,
    explanation: "ホームセンター事業への進出は1986年で、都城市に1号店となる「ハンズマン吉尾店」を開店しました。"
  },
  {
    id: 49,
    category: "商業・金融",
    question: "ハンズマンが株式を店頭登録(現JASDAQ上場)したのは西暦何年ですか?",
    options: [
      "1995年",
      "1998年",
      "2000年",
      "2005年"
    ],
    correctAnswer: 2,
    explanation: "豊富な品揃えと顧客目線の店舗づくりで支持を集め、2000年にはジャスダック証券取引所に上場を果たしています。"
  },
  {
    id: 50,
    category: "商業・金融",
    question: "1932年に日向興業銀行として設立された、宮崎県の第一地方銀行は何ですか?",
    options: [
      "宮崎太陽銀行",
      "宮崎銀行",
      "鹿児島銀行",
      "肥後銀行"
    ],
    correctAnswer: 1,
    explanation: "宮崎銀行は、1932年に日向興業銀行として設立されたのが始まりです。"
  },
  {
    id: 51,
    category: "商業・金融",
    question: "宮崎銀行が現在の商号に変更したのは西暦何年ですか?",
    options: [
      "1943年",
      "1953年",
      "1962年",
      "1985年"
    ],
    correctAnswer: 2,
    explanation: "複数の銀行との合併を経て、1962年に現在の商号に変更されました。"
  },
  {
    id: 52,
    category: "商業・金融",
    question: "1941年に県内4つの無尽会社が合併して設立された宮崎太陽銀行の前身の社名は何ですか?",
    options: [
      "日向無尽株式会社",
      "宮崎無尽株式会社",
      "昭明無尽株式会社",
      "日州無尽株式会社"
    ],
    correctAnswer: 1,
    explanation: "宮崎太陽銀行は、1941年に県内4つの無尽会社が合併して設立された宮崎無尽株式会社を前身とします。"
  },
  {
    id: 53,
    category: "商業・金融",
    question: "宮崎無尽株式会社が宮崎相互銀行に商号を変更したのは西暦何年ですか?",
    options: [
      "1941年",
      "1951年",
      "1961年",
      "1971年"
    ],
    correctAnswer: 1,
    explanation: "1951年に宮崎相互銀行となり、その後現在の行名へと変更されました。"
  },
  {
    id: 54,
    category: "商業・金融",
    question: "1973年に宮崎寿屋百貨店(後のカリーノ宮崎)が開業したのは橘通りのどこですか?",
    options: [
      "橘通西三丁目",
      "橘通東三丁目",
      "橘通西四丁目",
      "橘通東四丁目"
    ],
    correctAnswer: 1,
    explanation: "1973年に宮崎寿屋百貨店が橘通東三丁目に開業しました。"
  },
  {
    id: 55,
    category: "商業・金融",
    question: "橘通りのアーケードが最初に完成したのは西暦何年ですか?",
    options: [
      "1963年",
      "1967年",
      "1973年",
      "1990年"
    ],
    correctAnswer: 1,
    explanation: "1970年代には歩道にアーケードが設置されるなど、まさに宮崎の「顔」として発展しました。"
  },

  // 第5部:インフラ・物流・交通編 (問56-75)
  {
    id: 56,
    category: "インフラ・物流・交通",
    question: "宮崎市にある、研究開発型企業向けの工業団地で「テクノリサーチパーク」と名付けられているものはどれですか?",
    options: [
      "宮崎テクノリサーチパーク",
      "佐土原中央工業団地",
      "宮崎ハイテク工業団地",
      "宮崎学園都市ハイテクパーク"
    ],
    correctAnswer: 0,
    explanation: "宮崎市内およびその周辺には、「宮崎テクノリサーチパーク」や「宮崎ハイテク工業団地」といった名称の工業団地が点在しています。"
  },
  {
    id: 57,
    category: "インフラ・物流・交通",
    question: "旭化成などを中心とした化学工業が発達した、宮崎県北部の工業地域の名称は何ですか?",
    options: [
      "宮崎臨海工業地域",
      "日向延岡工業地域",
      "都城盆地工業地域",
      "県西テクノポリス地域"
    ],
    correctAnswer: 1,
    explanation: "県北の「日向延岡工業地域」は、旭化成を中心とする化学工業の一大集積地として歴史的に発展してきました。"
  },
  {
    id: 58,
    category: "インフラ・物流・交通",
    question: "日向市で新たに整備が進められている工業団地の名称は何ですか?",
    options: [
      "細島臨港工業団地",
      "日向中央工業団地",
      "東郷工業団地",
      "美々津工業団地"
    ],
    correctAnswer: 2,
    explanation: "近年では、日向市に新たな「東郷工業団地」の整備計画が進められるなど、将来の産業立地に向けた投資も継続されています。"
  },
  {
    id: 59,
    category: "インフラ・物流・交通",
    question: "日向延岡工業地域の物流を支える国の重要港湾は何ですか?",
    options: [
      "宮崎港",
      "油津港",
      "細島港",
      "内海港"
    ],
    correctAnswer: 2,
    explanation: "細島港(日向市)は日向延岡工業地域を後背地に持つこの港で、多様な貨物を取り扱う総合的な物流拠点です。"
  },
  {
    id: 60,
    category: "インフラ・物流・交通",
    question: "細島港で取り扱われている品目として、適切でないものはどれですか?",
    options: [
      "輸入石炭",
      "セメント",
      "木材チップ",
      "コンテナ貨物"
    ],
    correctAnswer: 3,
    explanation: "細島港ではコンテナ貨物をはじめ、化学工場の原料となる輸入石炭や原塩、セメント、木材などが主要な取扱品目です。"
  },
  {
    id: 61,
    category: "インフラ・物流・交通",
    question: "日南市にあり、主に製紙産業に関連する貨物を取り扱う港湾は何ですか?",
    options: [
      "宮崎港",
      "油津港",
      "細島港",
      "志布志港"
    ],
    correctAnswer: 1,
    explanation: "油津港(日南市)は県南部に位置し、特定の産業に特化した性格を持っています。"
  },
  {
    id: 62,
    category: "インフラ・物流・交通",
    question: "油津港の主要な取扱品目は何ですか?",
    options: [
      "自動車と電子部品",
      "化学薬品と原塩",
      "砂利と鉄鋼",
      "木材チップと紙・パルプ"
    ],
    correctAnswer: 3,
    explanation: "主な取扱品目は、日南市内の製紙工場で使用される木材チップと、そこで生産された紙・パルプ製品です。"
  },
  {
    id: 63,
    category: "インフラ・物流・交通",
    question: "宮崎市に本社を置き、宮崎空港を拠点とする航空会社は何ですか?",
    options: [
      "日本航空",
      "全日本空輸",
      "ソラシドエア",
      "ジェットスター・ジャパン"
    ],
    correctAnswer: 2,
    explanation: "宮崎県の空の玄関口である宮崎空港を拠点とする航空会社が、ソラシドエアです。"
  },
  {
    id: 64,
    category: "インフラ・物流・交通",
    question: "ソラシドエアが設立された当初の社名は何ですか?",
    options: [
      "スカイネットアジア航空",
      "パンアジア航空",
      "九州国際航空",
      "宮崎エアラインズ"
    ],
    correctAnswer: 1,
    explanation: "同社は宮崎市に本社を置いていますが、その設立は1997年、福岡市での「パンアジア航空」が始まりでした。"
  },
  {
    id: 65,
    category: "インフラ・物流・交通",
    question: "ソラシドエアが「スカイネットアジア航空」に商号を変更し、本社を宮崎市に移転したのは西暦何年ですか?",
    options: [
      "1997年",
      "1999年",
      "2000年",
      "2002年"
    ],
    correctAnswer: 2,
    explanation: "1999年に「スカイネットアジア航空」へ商号を変更し、翌2000年に本社を宮崎市へ移転しました。"
  },
  {
    id: 66,
    category: "インフラ・物流・交通",
    question: "スカイネットアジア航空が現在の「ソラシドエア」というブランド名を導入したのは西暦何年ですか?",
    options: [
      "2006年",
      "2009年",
      "2011年",
      "2015年"
    ],
    correctAnswer: 2,
    explanation: "その後、経営危機を産業再生機構の支援で乗り越え、2011年に現在のブランド名である「ソラシドエア」を導入しました。"
  },
  {
    id: 67,
    category: "インフラ・物流・交通",
    question: "ソラシドエア(当時スカイネットアジア航空)が最初に就航した路線はどれですか?",
    options: [
      "宮崎 - 福岡",
      "宮崎 - 大阪(伊丹)",
      "東京(羽田) - 宮崎",
      "東京(羽田) - 熊本"
    ],
    correctAnswer: 2,
    explanation: "最初の就航路線は、2002年8月1日に開設された東京(羽田)-宮崎線であり、これが同社の事業の礎となりました。"
  },
  {
    id: 68,
    category: "インフラ・物流・交通",
    question: "ソラシドエアの最初の路線が開設されたのはいつですか?",
    options: [
      "2000年9月1日",
      "2002年8月1日",
      "2004年6月25日",
      "2006年4月1日"
    ],
    correctAnswer: 1,
    explanation: "2002年8月1日に東京(羽田)-宮崎線が開設されました。"
  },
  {
    id: 69,
    category: "インフラ・物流・交通",
    question: "スカイネットアジア航空が経営支援を申請した機関はどこですか?",
    options: [
      "日本政策投資銀行",
      "整理回収機構",
      "産業再生機構",
      "中小企業基盤整備機構"
    ],
    correctAnswer: 2,
    explanation: "経営危機を産業再生機構の支援で乗り越えました。"
  },
  {
    id: 70,
    category: "インフラ・物流・交通",
    question: "ソラシドエアがANAとのコードシェア(共同運航)を開始したのは西暦何年ですか?",
    options: [
      "2004年",
      "2006年",
      "2008年",
      "2010年"
    ],
    correctAnswer: 1,
    explanation: "2006年からANAとのコードシェア(共同運航)を開始しました。"
  },
  {
    id: 71,
    category: "インフラ・物流・交通",
    question: "ソラシドエアが地域振興を目的に開始した、自治体との共同PRを行う機体活用プロジェクトの名称は何ですか?",
    options: [
      "ソラタビプロジェクト",
      "空恋 〜空で街と恋をする〜",
      "ウィング・オブ・九州",
      "スマイルフライト計画"
    ],
    correctAnswer: 1,
    explanation: "地域振興を目的に開始した、自治体との共同PRを行う機体活用プロジェクト「空恋 〜空で街と恋をする〜」があります。"
  },
  {
    id: 72,
    category: "インフラ・物流・交通",
    question: "宮崎市の工業団地の中で、最も面積が広いのはどれですか?",
    options: [
      "宮崎テクノリサーチパーク",
      "宮崎ハイテク工業団地",
      "宮崎学園都市ハイテクパーク",
      "花見工業団地"
    ],
    correctAnswer: 0,
    explanation: "宮崎テクノリサーチパークは研究開発型企業やハイテク企業の受け皿となっています。"
  },
  {
    id: 73,
    category: "インフラ・物流・交通",
    question: "東郷工業団地から最も近い高速道路のインターチェンジはどこですか?",
    options: [
      "宮崎西IC",
      "西都IC",
      "延岡IC",
      "日向IC"
    ],
    correctAnswer: 3,
    explanation: "東郷工業団地は日向市にあり、最寄りのインターチェンジは日向ICです。"
  },
  {
    id: 74,
    category: "インフラ・物流・交通",
    question: "ソラシドエアのハブ空港(拠点空港ではない)はどこですか?",
    options: [
      "福岡空港",
      "宮崎空港",
      "鹿児島空港",
      "東京国際空港(羽田空港)"
    ],
    correctAnswer: 0,
    explanation: "ソラシドエアは宮崎空港を拠点としていますが、ハブ空港は福岡空港となっています。"
  },
  {
    id: 75,
    category: "インフラ・物流・交通",
    question: "油津港にある、製紙工場で使用する木材チップを荷揚げ・保管するための集積所の名称は何ですか?",
    options: [
      "チップサイロ",
      "チップヤード",
      "ウッドターミナル",
      "パルプセンター"
    ],
    correctAnswer: 1,
    explanation: "油津港には木材チップを荷揚げ・保管するためのチップヤードがあります。"
  },

  // 第6部:経済史・その他編 (問76-100)
  {
    id: 76,
    category: "経済史・その他",
    question: "1980年代に国が推進し、宮崎県のハイテク工業団地造成の背景となった計画は何ですか?",
    options: [
      "日本列島改造論",
      "マルチメディア推進計画",
      "テクノポリス構想",
      "e-Japan戦略"
    ],
    correctAnswer: 2,
    explanation: "1980年代に国が推進した「テクノポリス構想」は、地方都市に先端技術産業を集積させることを目的とした計画でした。"
  },
  {
    id: 77,
    category: "経済史・その他",
    question: "2010年に宮崎県の経済に甚大な被害をもたらした家畜の伝染病は何ですか?",
    options: [
      "鳥インフルエンザ",
      "豚熱(CSF)",
      "口蹄疫(FMD)",
      "牛海綿状脳症(BSE)"
    ],
    correctAnswer: 2,
    explanation: "2010年に発生した口蹄疫の流行は、宮崎県の経済と社会に壊滅的な打撃を与えました。"
  },
  {
    id: 78,
    category: "経済史・その他",
    question: "2010年の口蹄疫問題による、宮崎県内の経済的影響額の総額(推計)はいくらですか?",
    options: [
      "約825億円",
      "約950億円",
      "約1,500億円",
      "約2,350億円"
    ],
    correctAnswer: 3,
    explanation: "県が試算した経済的影響額は、総額で約2,350億円という甚大なものでした。"
  },
  {
    id: 79,
    category: "経済史・その他",
    question: "2010年の口蹄疫問題で、最も大きな経済的影響を受けたと試算されている分野はどれですか?",
    options: [
      "畜産出荷額への影響",
      "畜産関連産業への影響",
      "食肉関連産業への影響",
      "商工関連産業への影響"
    ],
    correctAnswer: 3,
    explanation: "特に、観光客の減少や消費自粛によって商業・サービス業が受けた打撃は約950億円に達し、直接的な被害額を上回りました。"
  },
  {
    id: 80,
    category: "経済史・その他",
    question: "2010年の口蹄疫問題における、畜産出荷額への影響額(推計)はいくらですか?",
    options: [
      "約89億円",
      "約478億円",
      "約825億円",
      "約950億円"
    ],
    correctAnswer: 2,
    explanation: "畜産そのものの被害額(殺処分された家畜の評価額や出荷停止による損失)は約825億円でした。"
  },
  {
    id: 81,
    category: "経済史・その他",
    question: "2010年の口蹄疫問題の際、県NPO活動支援センターが寄付を活用して行った支援活動は何ですか?",
    options: [
      "畜産農家への経営資金の直接給付",
      "影響を受けた家庭の子供への奨学金給付",
      "観光施設への復興クーポンの発行",
      "県産品の全国への無料配送キャンペーン"
    ],
    correctAnswer: 1,
    explanation: "復興に向けては全国から多くの義援金が寄せられ、影響を受けた家庭の子供たちに奨学金を給付するNPOの活動など、官民一体となった取り組みが行われました。"
  },
  {
    id: 82,
    category: "経済史・その他",
    question: "宮崎県の産業構造を「デュアル・エンジン」と表現した場合、「資源立脚型エンジン」に該当しない業種はどれですか?",
    options: [
      "食料品製造業",
      "飲料・たばこ・飼料製造業",
      "電子部品・デバイス・電子回路製造業",
      "木材・木製品製造業"
    ],
    correctAnswer: 2,
    explanation: "電子部品・デバイス・電子回路製造業は「グローバル技術エンジン」に該当します。資源立脚型エンジンは地域の資源を加工し、付加価値を生み出すモデルです。"
  },
  {
    id: 83,
    category: "経済史・その他",
    question: "宮崎県の産業構造における「グローバル技術エンジン」を代表する企業として、適切でないものはどれですか?",
    options: [
      "宮崎日機装",
      "旭化成(延岡)",
      "ハンズマン",
      "宮崎キヤノン"
    ],
    correctAnswer: 2,
    explanation: "ハンズマンは小売業であり、グローバル技術エンジンには該当しません。宮崎日機装、旭化成、宮崎キヤノンは世界市場で圧倒的なシェアを誇る企業です。"
  },
  {
    id: 84,
    category: "経済史・その他",
    question: "世界市場で高いシェアを持つが、一般消費者にはあまり知られていない優良企業を指す経済用語は何ですか?",
    options: [
      "ユニコーン企業",
      "グローバル・スタンダード企業",
      "ブルーオーシャン企業",
      "ヒドゥン・チャンピオン(隠れたチャンピオン)"
    ],
    correctAnswer: 3,
    explanation: "宮崎県には、世界市場で圧倒的なシェアを誇る「隠れたチャンピオン企業」が県内に拠点を構えています。"
  },
  {
    id: 85,
    category: "経済史・その他",
    question: "多くの地方都市が経験した、モータリゼーションの進展による中心市街地の衰退と郊外店舗の隆盛という現象を何と呼びますか?",
    options: [
      "ジェントリフィケーション",
      "ドーナツ化現象",
      "コンパクトシティ化",
      "アーバン・スプロール"
    ],
    correctAnswer: 1,
    explanation: "1990年代以降、モータリゼーションの進展とともに郊外型の大規模店舗が増加すると、橘通りの歩行者通行量は減少傾向に転じます。これは日本の多くの地方都市が経験した中心市街地の空洞化という典型的な課題でした。"
  },
  {
    id: 86,
    category: "経済史・その他",
    question: "宮崎市の橘通りで、1952年に開業した百貨店は何ですか?",
    options: [
      "宮崎山形屋",
      "宮崎寿屋百貨店",
      "橘百貨店",
      "ボンベルタ橘"
    ],
    correctAnswer: 0,
    explanation: "1950年代には宮崎山形屋や橘百貨店(後のカリーノ宮崎)といった大型百貨店が相次いで開業・移転しました。"
  },
  {
    id: 87,
    category: "経済史・その他",
    question: "霧島酒造の焼酎粕リサイクルプラントが最初に落成したのは西暦何年ですか?",
    options: [
      "1999年",
      "2003年",
      "2006年",
      "2011年"
    ],
    correctAnswer: 1,
    explanation: "霧島酒造は環境への配慮から焼酎粕リサイクルプラントを2003年に落成させました。"
  },
  {
    id: 88,
    category: "経済史・その他",
    question: "旭化成のベンベルグ工場では、現在工場見学の受け入れをどうしていますか?",
    options: [
      "毎日受け入れている",
      "予約制で受け入れている",
      "休止している",
      "バーチャル見学のみ受け入れている"
    ],
    correctAnswer: 2,
    explanation: "現在、ベンベルグ工場の見学は休止されています。"
  },
  {
    id: 89,
    category: "経済史・その他",
    question: "ハンズマンが加盟した、日本DIY商品共同流通グループの略称は何ですか?",
    options: [
      "JDC",
      "DMC",
      "DIY-JAPAN",
      "HMG"
    ],
    correctAnswer: 0,
    explanation: "ハンズマンは日本DIY商品共同流通グループ(JDC)に加盟しています。"
  },
  {
    id: 90,
    category: "経済史・その他",
    question: "宮崎太陽銀行が九州地区の相互銀行と共同でオンラインシステム(SBK)を稼働させたのは西暦何年ですか?",
    options: [
      "1964年",
      "1977年",
      "1984年",
      "1991年"
    ],
    correctAnswer: 1,
    explanation: "1977年に九州地区の相互銀行と共同でオンラインシステム(SBK)を稼働させました。"
  },
  {
    id: 91,
    category: "経済史・その他",
    question: "ソラシドエアが機体活用プロジェクト「空恋」の第1号機としてラッピングを施した宮崎県の町はどこですか?",
    options: [
      "高千穂町",
      "日南市",
      "綾町",
      "都農町"
    ],
    correctAnswer: 2,
    explanation: "ソラシドエアは地域振興を目的に自治体との共同PRを行う「空恋」プロジェクトを展開しています。"
  },
  {
    id: 92,
    category: "経済史・その他",
    question: "2010年の口蹄疫問題の際、無観客試合で開幕したスポーツイベントは何ですか?",
    options: [
      "Jリーグ・キャンプ",
      "プロ野球春季キャンプ",
      "全国高校野球選手権大会宮崎大会",
      "国民体育大会宮崎県予選"
    ],
    correctAnswer: 1,
    explanation: "2010年の口蹄疫問題の際、プロ野球春季キャンプは無観客試合で開幕されました。"
  },
  {
    id: 93,
    category: "経済史・その他",
    question: "宮崎日機装が部品を製造しているアメリカのeVTOL開発企業はどこですか?",
    options: [
      "ボーイング社",
      "テスラ社",
      "ジョビー・アビエーション社",
      "エアバス社"
    ],
    correctAnswer: 2,
    explanation: "宮崎日機装は次世代の移動手段として注目される「空飛ぶクルマ」(eVTOL)の部品をジョビー・アビエーション社向けに開発しています。"
  },
  {
    id: 94,
    category: "経済史・その他",
    question: "霧島酒造が創業70周年記念ボトルとして発売した商品の名前は何ですか?",
    options: [
      "順吉",
      "黒霧島源酒",
      "吉助",
      "百瑠璃"
    ],
    correctAnswer: 2,
    explanation: "霧島酒造は創業70周年を記念して「吉助」という商品を発売しました。"
  },
  {
    id: 95,
    category: "経済史・その他",
    question: "宮崎市の歓楽街「ニシタチ」の発展の皮切りとなった、昭和31年にオープンした店の名前は何ですか?",
    options: [
      "安兵衛小路",
      "マルコポーロ",
      "エリントンクラブ",
      "トリスバー「赤煉瓦」"
    ],
    correctAnswer: 3,
    explanation: "ニシタチの発展の皮切りとなったのは昭和31年にオープンした「トリスバー赤煉瓦」です。"
  },
  {
    id: 96,
    category: "経済史・その他",
    question: "1998年に廃止された、テクノポリス計画の根拠法であった法律の通称は何ですか?",
    options: [
      "新事業創出促進法",
      "地域産業高度化法",
      "テクノポリス法",
      "頭脳立地法"
    ],
    correctAnswer: 2,
    explanation: "1998年にテクノポリス法は廃止されましたが、この政策は宮崎県の産業構造転換に大きな影響を与えました。"
  },
  {
    id: 97,
    category: "経済史・その他",
    question: "宮崎銀行が設立された際の名称は何ですか?",
    options: [
      "日向中央銀行",
      "旧宮崎銀行",
      "延岡銀行",
      "日向興業銀行"
    ],
    correctAnswer: 3,
    explanation: "宮崎銀行は、1932年に日向興業銀行として設立されたのが始まりです。"
  },
  {
    id: 98,
    category: "経済史・その他",
    question: "霧島酒造がスピリッツとして発売した「冬蟲夏草酒」の商品名は何ですか?",
    options: [
      "金霧島",
      "黒宝霧島",
      "Ax霧島",
      "〈玉〉金霧島"
    ],
    correctAnswer: 2,
    explanation: "霧島酒造は「Ax霧島」という冬蟲夏草酒をスピリッツとして発売しています。"
  },
  {
    id: 99,
    category: "経済史・その他",
    question: "2022年の宮崎県の製造品出荷額等(1兆8,195億円)は、どの都道府県と近い規模ですか?",
    options: [
      "沖縄県",
      "佐賀県",
      "大分県",
      "鹿児島県"
    ],
    correctAnswer: 2,
    explanation: "宮崎県の製造品出荷額等約1.8兆円は、大分県と近い規模となっています。"
  },
  {
    id: 100,
    category: "経済史・その他",
    question: "2010年の口蹄疫危機が宮崎経済に与えた最大の教訓として、最も適切なものはどれですか?",
    options: [
      "畜産業はリスクが高いため、他産業への転換を急ぐべきである",
      "観光業は外部要因に弱いため、製造業への投資を優先すべきである",
      "第一次産業の危機は、地域経済システム全体の危機に直結する",
      "グローバル企業の誘致が、地域のリスクを分散させる唯一の方法である"
    ],
    correctAnswer: 2,
    explanation: "この危機は、宮崎県の経済にとって、第一次産業の健全性が商業や観光業の繁栄と分かちがたく結びついていることを痛感させる、厳しい教訓となりました。第一次産業の脆弱性が地域全体の存続に関わる脅威であるという認識を深く刻み込むことになりました。"
  }
];
